export default __webpack_public_path__ + "static/media/starryBG.9a4fdaa0.svg";